<script setup lang="ts">
const props = withDefaults(defineProps<{
    activeFilter?: string | null
}>(), {
    activeFilter: null
})

const localePath = useLocalePath()

function linkClass(filter: string | null): string {
    const isActive = props.activeFilter === filter
    return `text-sm transition-colors ${isActive ? 'text-primary font-bold' : 'text-neutral hover:text-primary'}`
}
</script>

<template>
    <nav class="w-full bg-base-100 border-b border-border">
        <div class="mx-auto w-full max-w-8xl px-3">
            <ul class="flex items-center flex-nowrap overflow-x-scroll lg:overflow-x-hidden whitespace-nowrap gap-3 py-3">
                <li class="flex items-center">
                    <FoundationLink
                        :href="localePath('/marken')"
                        :class="linkClass(null)"
                    >
                        {{ $t('marken.filter.all') }}
                    </FoundationLink>
                </li>
                <li class="flex items-center">
                    <FoundationLink
                        :href="localePath('/marken/damenschuhe')"
                        :class="linkClass('damenschuhe')"
                    >
                        {{ $t('marken.filter.women') }}
                    </FoundationLink>
                </li>
                <li class="flex items-center">
                    <FoundationLink
                        :href="localePath('/marken/herrenschuhe')"
                        :class="linkClass('herrenschuhe')"
                    >
                        {{ $t('marken.filter.men') }}
                    </FoundationLink>
                </li>
                <li class="flex items-center">
                    <FoundationLink
                        :href="localePath('/marken/kinderschuhe')"
                        :class="linkClass('kinderschuhe')"
                    >
                        {{ $t('marken.filter.kids') }}
                    </FoundationLink>
                </li>
            </ul>
        </div>
    </nav>
</template>